import LandingSocialBannerSection from './LandingSocialBannerSection';

export default LandingSocialBannerSection;
